<template>
<div>
    <div id="gallery">
        <slot name="paintings-slot"></slot>
    <stack
            :column-min-width="145"
            :gutter-width="3.5"
            :gutter-height="0"
            monitor-images-loaded
    >
        <stack-item
                v-for="item in images" v-bind:key="item.id"
                style="transition: transform 300ms"
        >
            <div style="overflow: hidden" @click="handleModal(item)">
            <img v-bind:src="item.thumb" class="thumbs">
            </div>
        </stack-item>
    </stack>
        </div>
    <BaseModal ref="modal" :painting="painting"/>
</div>


</template>

<script>
    import { Stack, StackItem } from "vue-stack-grid"

    export default {
        name: "Paintings",
        components: {
            Stack,
            StackItem
        },

        data: function () {
            return {
                images: [
                    {
                    "url": '/paintings/1978-425-a-childs-garden-of-universes.jpg',
                    "thumb": '/paintings/thumbs/1978-425-a-childs-garden-of-universes-thumb.jpg',
                        "year": '1978',
                        "art_width": '24',
                        "art_height": '36',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'A Child\'s Garden of Universes',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/425-1983-night-of-the-dragon.jpg",
                        "thumb": "/paintings/thumbs/425-1983-night-of-the-dragon-thumb.jpg",
                        "year": '1982',
                        "art_width": '16',
                        "art_height": '24',
                        "description": '',
                        "memo": '',
                        "owner": 'Jim W. Coleman',
                        "media": 'Acrylic',
                        "material": 'board',
                        "title": 'Night of the Dragon',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1976-425-the-money-changer.jpg",
                        "thumb": "/paintings/thumbs/1976-425-the-money-changer-thumbs.jpg",
                        "year": '1976',
                        "art_width": '36',
                        "art_height": '24',
                        "description": '',
                        "memo": '',
                        "owner": 'James W Coleman, Sr.',
                        "media": 'Mixed media',
                        "material": '',
                        "title": 'The Money Changer',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1977-425-by-jove.jpg",
                        "thumb": "/paintings/thumbs/1977-425-by-jove-thumb.jpg",
                        "year": '1977',
                        "art_width": '30',
                        "art_height": '24',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'By Jove!',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/425-1980-night-side.jpg",
                        "thumb": "/paintings/thumbs/425-1980-night-side-thumb.jpg",
                        "year": '1980',
                        "art_width": '12',
                        "art_height": '17',
                        "description": '',
                        "memo": '',
                        "owner": 'Jim W. Coleman',
                        "media": 'Oil',
                        "material": '',
                        "title": 'Night Side',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1979-850x510-stonehenge.jpg",
                        "thumb": "/paintings/thumbs/1979-850x510-stonehenge-thumb.jpg",
                        "year": '1979',
                        "art_width": '30',
                        "art_height": '20',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Oil',
                        "material": 'board',
                        "title": 'Stonehenge',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1977-425-victims-of-the-storm.jpg",
                        "thumb": "/paintings/thumbs/1977-425-victims-of-the-storm-thumb.jpg",
                        "year": '1977',
                        "art_width": '36',
                        "art_height": '24',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Victims of the Storm',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/0000-425-no-information-space-fighters-and-birds.jpg",
                        "thumb": "/paintings/thumbs/0000-425-no-information-space-fighters-and-birds-thumb.jpg",
                        "year": '',
                        "art_width": '',
                        "art_height": '',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": '',
                        "material": '',
                        "title": 'Untitled',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/425-1983-death-mask-2.jpg",
                        "thumb": "/paintings/thumbs/425-1983-death-mask-2-thumb.jpg",
                        "year": '1983',
                        "art_width": '24',
                        "art_height": '30',
                        "description": '',
                        "memo": '',
                        "owner": 'Jim W. Coleman',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Death Mask II',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1977-425-as-they-walked-on-to-the-bridge.jpg",
                        "thumb": "/paintings/thumbs/1977-425-as-they-walked-on-to-the-bridge-thumb.jpg",
                        "year": '1977',
                        "art_width": '24',
                        "art_height": '36',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'As They Walked onto the Bridge',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1977-425-trees-on-the-east-verde-river.jpg",
                        "thumb": "/paintings/thumbs/1977-425-trees-on-the-east-verde-river-thumb.jpg",
                        "year": '1977',
                        "art_width": '20',
                        "art_height": '16',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Trees on the East Verde River',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1977-425-the-touch.jpg",
                        "thumb": "/paintings/thumbs/1977-425-the-touch-thumb.jpg",
                        "year": '1977',
                        "art_width": '',
                        "art_height": '',
                        "description": '',
                        "memo": '',
                        "owner": 'Luther Carroll',
                        "media": '',
                        "material": '',
                        "title": 'The Touch',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1983-the-meeting.jpg",
                        "thumb": "/paintings/thumbs/1983-the-meeting-thumb.jpg",
                        "year": '1983',
                        "art_width": '',
                        "art_height": '',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'The Meeting',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1981-850x510-dreadnaught-arizona.jpg",
                        "thumb": "/paintings/thumbs/1981-850x510-dreadnaught-arizona-thumb.jpg",
                        "year": '1981',
                        "art_width": '42',
                        "art_height": '42',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Oil',
                        "material": 'canvas',
                        "title": 'Dreadnaught Arizona',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1979-425-garden-of-light.jpg",
                        "thumb": "/paintings/thumbs/1979-425-garden-of-light-thumb.jpg",
                        "year": '1979',
                        "art_width": '20',
                        "art_height": '30',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": 'canvas board',
                        "title": 'Garden of Light',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1978-untitled-24x36-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1978-untitled-24x36-acrylic-thumb.jpg",
                        "year": '',
                        "art_width": '24',
                        "art_height": '36',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": '',
                        "material": '',
                        "title": 'Untitled',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1978-425-the-white-tower.jpg",
                        "thumb": "/paintings/thumbs/1978-425-the-white-tower-thumb.jpg",
                        "year": '1978',
                        "art_width": '24',
                        "art_height": '36',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'The White Tower',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1977-425-starfall-envoys.jpg",
                        "thumb": "/paintings/thumbs/1977-425-starfall-envoys-thumb.jpg",
                        "year": '1977',
                        "art_width": '20',
                        "art_height": '18',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Starfall Envoys',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1978-425-the-piano-player-20x30.jpg",
                        "thumb": "/paintings/thumbs/1978-425-the-piano-player-20x30-thumb.jpg",
                        "year": '1978',
                        "art_width": '20',
                        "art_height": '30',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'The Piano Player',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1977-425-o-gods.jpg",
                        "thumb": "/paintings/thumbs/1977-425-o-gods-thumb.jpg",
                        "year": '1977',
                        "art_width": '20',
                        "art_height": '30',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'O Gods',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1977-425-night-attack.jpg",
                        "thumb": "/paintings/thumbs/1977-425-night-attack-thumb.jpg",
                        "year": '1977',
                        "art_width": '18',
                        "art_height": '24',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Night Attack',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/0000-dan-schmidt-plane-owned-by-jim-jr.jpg",
                        "thumb": "/paintings/thumbs/0000-dan-schmidt-plane-owned-by-jim-jr-thumb.jpg",
                        "year": '',
                        "art_width": '',
                        "art_height": '',
                        "description": '',
                        "memo": '',
                        "owner": 'Jim Coleman, Jr.',
                        "media": '',
                        "material": '',
                        "title": 'Unknown title',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1983-becalmed-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1983-becalmed-acrylic-thumb.jpg",
                        "year": '1983',
                        "art_width": '',
                        "art_height": '',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Becalmed',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1980-light-cruiser-24x18-oil-on-board.jpg",
                        "thumb": "/paintings/thumbs/1980-light-cruiser-24x18-oil-on-board-thumb.jpg",
                        "year": '1980',
                        "art_width": '24',
                        "art_height": '18',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Oil',
                        "material": 'board',
                        "title": 'Light Cruiser',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1980-masque-30x20-acrylic-sold.jpg",
                        "thumb": "/paintings/thumbs/1980-masque-30x20-acrylic-sold-thumb.jpg",
                        "year": '1980',
                        "art_width": '30',
                        "art_height": '24',
                        "description": '',
                        "memo": '',
                        "owner": 'Unknown',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Masque',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1980-messenger-30x24.jpg",
                        "thumb": "/paintings/thumbs/1980-messenger-30x24-thumb.jpg",
                        "year": '1980',
                        "art_width": '30',
                        "art_height": '24',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": '',
                        "material": '',
                        "title": 'Messenger',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1980-moonstone-15x20-acrylic-on-board.jpg",
                        "thumb": "/paintings/thumbs/1980-moonstone-15x20-acrylic-on-board-thumb.jpg",
                        "year": '1980',
                        "art_width": '15',
                        "art_height": '20',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": 'board',
                        "title": 'Moonstone',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1980-the-conversation-12x14-acrylic-on-board.jpg",
                        "thumb": "/paintings/thumbs/1980-the-conversation-12x14-acrylic-on-board-thumb.jpg",
                        "year": '1980',
                        "art_width": '12',
                        "art_height": '14',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": 'board',
                        "title": 'The Conversation',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1980-the-high-castle-16x14-acrylic-on-board.jpg",
                        "thumb": "/paintings/thumbs/1980-the-high-castle-16x14-acrylic-on-board-thumb.jpg",
                        "year": '1980',
                        "art_width": '16',
                        "art_height": '14',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": 'board',
                        "title": 'The High Castle',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1980-the-messenger-16x20-oil.jpg",
                        "thumb": "/paintings/thumbs/1980-the-messenger-16x20-oil-thumb.jpg",
                        "year": '1980',
                        "art_width": '16',
                        "art_height": '20',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Oil',
                        "material": '',
                        "title": 'The Messenger',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1980-the-ring-18x14-acrylic-on-board.jpg",
                        "thumb": "/paintings/thumbs/1980-the-ring-18x14-acrylic-on-board-thumb.jpg",
                        "year": '1980',
                        "art_width": '18',
                        "art_height": '14',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": 'board',
                        "title": 'The Ring',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1980-the-sacred-place-24x20-oil-on-board.jpg",
                        "thumb": "/paintings/thumbs/1980-the-sacred-place-24x20-oil-on-board-thumb.jpg",
                        "year": '1980',
                        "art_width": '24',
                        "art_height": '20',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Oil',
                        "material": 'board',
                        "title": 'The Sacred Place',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1981-battle-of-the-western-approaches-20-inch-round-acrylic-on-canvas.jpg",
                        "thumb": "/paintings/thumbs/1981-battle-of-the-western-approaches-20-inch-round-acrylic-on-canvas-thumb.jpg",
                        "year": '1981',
                        "art_width": '20',
                        "art_height": '20',
                        "description": 'Painted round rather than square or rectangular.',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": 'canvas',
                        "title": 'Battle of the Western Approaches',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1981-ceremony-18x24-acrylic-on-canvas.jpg",
                        "thumb": "/paintings/thumbs/1981-ceremony-18x24-acrylic-on-canvas-thumb.jpg",
                        "year": '1981',
                        "art_width": '18',
                        "art_height": '24',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": 'canvas',
                        "title": 'The Ceremony',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1981-the-marshes-of-lore-30x20-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1981-the-marshes-of-lore-30x20-acrylic-thumb.jpg",
                        "year": '1981',
                        "art_width": '30',
                        "art_height": '20',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'The Marshes of Lore',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1982-cumulus-30x15.jpg",
                        "thumb": "/paintings/thumbs/1982-cumulus-30x15-thumb.jpg",
                        "year": '1982',
                        "art_width": '30',
                        "art_height": '15',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": '',
                        "material": '',
                        "title": 'Cumulus',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1982-fire-and-water-nymphs-24x36-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1982-fire-and-water-nymphs-24x36-acrylic-thumb.jpg",
                        "year": '1982',
                        "art_width": '24',
                        "art_height": '36',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Fire and Water Nymphs',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1982-river-of-tears-16x24-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1982-river-of-tears-16x24-acrylic-thumb.jpg",
                        "year": '1982',
                        "art_width": '16',
                        "art_height": '24',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'River of Tears',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1982-triceratops-24x16.jpg",
                        "thumb": "/paintings/thumbs/1982-triceratops-24x16-thumb.jpg",
                        "year": '1982',
                        "art_width": '24',
                        "art_height": '16',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": '',
                        "material": '',
                        "title": 'Triceratops',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1983-he-forest-18x20-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1983-he-forest-18x20-acrylic-thumb.jpg",
                        "year": '1983',
                        "art_width": '18',
                        "art_height": '20',
                        "description": '',
                        "memo": '',
                        "owner": 'Jim W. Coleman',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'The Forest',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1983-saboteur-24x36-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1983-saboteur-24x36-acrylic-thumb.jpg",
                        "year": '1983',
                        "art_width": '24',
                        "art_height": '36',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Saboteur',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/19810-old-guard-28x18.jpg",
                        "thumb": "/paintings/thumbs/19810-old-guard-28x18-thumb.jpg",
                        "year": '1981',
                        "art_width": '28',
                        "art_height": '18',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": '',
                        "material": '',
                        "title": 'Old Guard',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/0000-no-information-island-statues.jpg",
                        "thumb": "/paintings/thumbs/0000-no-information-island-statues-thumb.jpg",
                        "year": '',
                        "art_width": '',
                        "art_height": '',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": '',
                        "material": '',
                        "title": 'Island Statues',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1975-11-the-bridge-17x17.jpg",
                        "thumb": "/paintings/thumbs/1975-11-the-bridge-17x17-thumb.jpg",
                        "year": '1975',
                        "art_width": '17',
                        "art_height": '17',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": '',
                        "material": '',
                        "title": 'The Bridge',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1977-eighth-day-falls-24x36-acrylic-sold.jpg",
                        "thumb": "/paintings/thumbs/1977-eighth-day-falls-24x36-acrylic-sold-thumb.jpg",
                        "year": '1977',
                        "art_width": '24',
                        "art_height": '36',
                        "description": '',
                        "memo": '',
                        "owner": 'Unknown',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Eighth Day Falls',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1978 29 RockFall 18x14 Acrylic.jpg",
                        "thumb": "/paintings/thumbs/1978 29 RockFall 18x14 Acrylic-thumb.jpg",
                        "year": '1978',
                        "art_width": '18',
                        "art_height": '24',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'RockFall',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1978-57-the-last-artifical-world-18x24-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1978-57-the-last-artifical-world-18x24-acrylic-thumb.jpg",
                        "year": '1978',
                        "art_width": '18',
                        "art_height": '24',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'The Last Artifical World',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1978-58-and-now-the-stars-24x18-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1978-58-and-now-the-stars-24x18-acrylic-thumb.jpg",
                        "year": '1978',
                        "art_width": '24',
                        "art_height": '18',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'And Now the Stars',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1978-iron-mountain-badlands-18x14-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1978-iron-mountain-badlands-18x14-acrylic-thumb.jpg",
                        "year": '1978',
                        "art_width": '18',
                        "art_height": '24',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Iron Mountain Badlands',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1978-untitled-36x24-acrylic-ship-at-sea.jpg",
                        "thumb": "/paintings/thumbs/1978-untitled-36x24-acrylic-ship-at-sea-thumb.jpg",
                        "year": '1978',
                        "art_width": '36',
                        "art_height": '24',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Ship at Sea',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1978-vision-in-a-black-hole-16x20-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1978-vision-in-a-black-hole-16x20-acrylic-thumb.jpg",
                        "year": '1978',
                        "art_width": '16',
                        "art_height": '20',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Vision in a Black Hole',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1979-aftermath-30x20-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1979-aftermath-30x20-acrylic-thumb.jpg",
                        "year": '1979',
                        "art_width": '30',
                        "art_height": '20',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Aftermath',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1979-dragons-krak-24x36-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1979-dragons-krak-24x36-acrylic-thumb.jpg",
                        "year": '1979',
                        "art_width": '24',
                        "art_height": '36',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Dragon\'s Krak',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1979-eclipse-the-terminal-line-24x36-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1979-eclipse-the-terminal-line-24x36-acrylic-thumb.jpg",
                        "year": '1979',
                        "art_width": '24',
                        "art_height": '36',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Eclipse: The Terminal Line',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1979-free-delivery-30x20-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1979-free-delivery-30x20-acrylic-thumb.jpg",
                        "year": '1979',
                        "art_width": '30',
                        "art_height": '20',
                        "description": '',
                        "memo": '',
                        "owner": 'Unknown',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Free Delivery',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1979-night-flight-30x20-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1979-night-flight-30x20-acrylic-thumb.jpg",
                        "year": '1979',
                        "art_width": '30',
                        "art_height": '20',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Night Flight',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1979-palace-of-the-winter-moon-24x24-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1979-palace-of-the-winter-moon-24x24-acrylic-thumb.jpg",
                        "year": '1979',
                        "art_width": '24',
                        "art_height": '24',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Palace of the Winter Moon',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1979-spellbinders-24x24-acrylic-detail.jpg",
                        "thumb": "/paintings/thumbs/1979-spellbinders-24x24-acrylic-detail-thumb.jpg",
                        "year": '1979',
                        "art_width": '24',
                        "art_height": '24',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Spellbinders',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1979-the-next-lost-monster-16x20-oil.jpg",
                        "thumb": "/paintings/thumbs/1979-the-next-lost-monster-16x20-oil-thumb.jpg",
                        "year": '1979',
                        "art_width": '16',
                        "art_height": '20',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Oil',
                        "material": '',
                        "title": 'The Next Lost Monster',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1979-the-universe-unfolding-20x30-acrylic-on-board.jpg",
                        "thumb": "/paintings/thumbs/1979-the-universe-unfolding-20x30-acrylic-on-board-thumb.jpg",
                        "year": '1979',
                        "art_width": '20',
                        "art_height": '30',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": 'board',
                        "title": 'The Universe Unfolding',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1980-boom-12x12-acrylic-on-board.jpg",
                        "thumb": "/paintings/thumbs/1980-boom-12x12-acrylic-on-board-thumb.jpg",
                        "year": '1980',
                        "art_width": '12',
                        "art_height": '12',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": 'board',
                        "title": 'Boom',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1980-dome-15x20-acrylic.jpg",
                        "thumb": "/paintings/thumbs/1980-dome-15x20-acrylic-thumb.jpg",
                        "year": '1980',
                        "art_width": '15',
                        "art_height": '20',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": '',
                        "title": 'Dome',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/1980-earth-genesis-young-land-infant-sea-20x15-acrylic-on-board.jpg",
                        "thumb": "/paintings/thumbs/1980-earth-genesis-young-land-infant-sea-20x15-acrylic-on-board-thumb.jpg",
                        "year": '1980',
                        "art_width": '20',
                        "art_height": '15',
                        "description": '',
                        "memo": '',
                        "owner": '',
                        "media": 'Acrylic',
                        "material": 'board',
                        "title": 'Earth Genesis Young Land Infant Sea',
                        "submitted_by": ''
                    },
                    {
                        "url": "/paintings/80_Infinite_horizons_134506.jpg",
                        "thumb": "/paintings/thumbs/80_Infinite_horizons_134506-thumb.jpg",
                        "year": '1980',
                        "art_width": '18',
                        "art_height": '24',
                        "description": '',
                        "memo": '',
                        "owner": 'James W Coleman, Sr.',
                        "media": '',
                        "material": '',
                        "title": 'Infinite Horizons',
                        "submitted_by": 'Phil Coleman'
                    },
                    {
                        "url": "/paintings/77_untitled_grandparents_20200830_133921.jpg",
                        "thumb": "/paintings/thumbs/77_untitled_grandparents_20200830_133921-thumb.jpg",
                        "year": '1977',
                        "art_width": '18',
                        "art_height": '24',
                        "description": '',
                        "memo": '',
                        "owner": 'James W Coleman, Sr.',
                        "media": '',
                        "material": '',
                        "title": 'In the Clouds of Magellan',
                        "submitted_by": 'Phil Coleman'
                    },
                  {
                    "url": "/paintings/154_1974_the_meadow.jpg",
                    "thumb": "/paintings/thumbs/154_1974_the_meadow-thumb.jpg",
                    "year": '1974',
                    "art_width": '30',
                    "art_height": '20',
                    "description": '',
                    "memo": '',
                    "owner": 'Cat Coleman',
                    "media": '',
                    "material": '',
                    "title": 'In the Meadow',
                    "submitted_by": 'Cat Coleman'
                  },
                    // {
                    // "url": "/paintings/.jpg",
                    // "thumb": "/paintings/thumbs/.jpg",
                    // "year": '',
                    // "art_width": '',
                    // "art_height": '',
                    // "description": '',
                    // "memo": '',
                    // "owner": '',
                    // "media": '',
                    // "material": '',
                    // "title": '',
                    //" submitted_by": ''
                    // },
                ],
                painting: {},
            };
        },



        computed: {},
        mounted() {
            this.painting = this.images[0]
        },
        ready: function () {
        },
        methods: {
            handleModal(item) {
                this.painting = item;
                this.$refs.modal.showModal();
            }
        }
    }
</script>

<style>
    .box {
        max-width: 100%;
        padding-top: 10px;
        max-height: 100vh;
    }
    .thumbs {
        width: 150px;
        min-width: 150px;
        max-width: 150px;
    }
</style>
